import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import './assets/css/app.theme.scss'
import 'vue-tel-input/vue-tel-input.css';

import { createApp, ref } from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";
import App from "./App.vue";
import appInfo from "./app-info";
import { createPinia } from 'pinia';
import { ReviewNavigatorPlugin } from './services/ReviewNavigator';
import { HomemoverApiClientPlugin } from './services/HomemoverApiClient';

themes.initialized(() => {
    const app = createApp(App);
    const pinia = createPinia();

    /* So the app knows when not to redirect the user when they click back
     * to go to the home page, we need to provide a global flag */
    const userRedirectedToPreviousStep = ref(false);

    app.provide('userRedirectedToPreviousStep', userRedirectedToPreviousStep);

    app.use(router);
    app.use(pinia);
    app.use(ReviewNavigatorPlugin);
    app.use(HomemoverApiClientPlugin);

    app.config.globalProperties.$appInfo = appInfo;
    app.mount('#app');
});
